// src/howlettBids.js — which basis/bid sources are HOWLETT'S, for the client
// half of the Cash Board switch (2026-10-14).
//
// The switch is app_config.cash_board_enabled. While it is off, Howlett's
// posted bids are withheld from everyone but Kevin and Mike — by RLS on the
// tables (sql/089), by api/_howlett-gate.js on the service-key endpoints, and
// by this filter on the portal surfaces that would otherwise render whatever
// arrives. A server-side scope is never the only guard on a portal surface.
//
// MIRRORED in api/_howlett-gate.js (CRA cannot import outside src/) and in
// sql/089's policy; tools/check-howlett-gate.js asserts all three agree.

export const HOWLETT_SOURCE_RE = /^(howlett|plenish)_/i;

export function isHowlettSource(source) {
  return HOWLETT_SOURCE_RE.test(String(source || ""));
}
